import AdminUsersIndexHeaderRow from './AdminUsersIndexHeaderRow';

export default AdminUsersIndexHeaderRow;
